import { __spreadArray } from "tslib";
import isArray from 'lodash/isArray';
import logger from '@main/externals/bss-package-logger/js/logger';
var _toolbox;
/**
 * BSSWatcher class
 */
var BSSWatcher = /** @class */ (function () {
    /**
     * @param {jQuery|HTMLElement} componentTemplate
     * @param {Object} componentConfig
     * @param {Object} config
     * @param {Object} toolbox
     * @param {EventManager} eventManager
     */
    function BSSWatcher(componentTemplate, componentConfig, config, toolbox, eventManager) {
        _toolbox = toolbox;
        /**
         * @desc subscriber prefix used as namespace to events and owner for subscriber
         * @type {String}
         */
        this._subscriberPrefix = _toolbox.$.now();
        /**
         * @desc stores event manager object
         * @type {EventManager}
         * @private
         */
        this._eventManager = eventManager;
        /**
         * @desc stores component template
         * @type {jQuery|HTMLElement}
         * @private
         */
        this._componentTemplate = componentTemplate;
        /**
         * @desc stores component config
         * @type {Object}
         * @private
         */
        this._componentConfig = componentConfig;
        /**
         * @desc stores watcher config
         * @type {Object}
         * @property {String} boundDataOperand - stores information wihich operand is bound to resultData
         * @property {String} effectSuccess - name of function called when condition is fulfilled
         * @property {String} effectFail - name of function called when condition isn't fulfilled
         * @property {String} operandLeft - stores operand left
         * @property {String} operandRight - stores oprand right
         * @property {String} operator - name of function used to compare operands
         */
        this._config = config;
        /**
         * @desc callback called after condition is fulfilled
         * @type {string}
         */
        this._conditionSuccessCallback = this._config.effectSuccess;
        /**
         * @desc callback called after condition isn't fulfilled
         * @type {string}
         * @private
         */
        this._conditionFailedCallback = this._config.effectFail;
        /**
         * @desc component state
         * @type {string}
         * @private
         */
        this._state = '';
        /**
         * @desc class which hides element
         * @type {string}
         */
        this.hideClass = this._config.hideClass || 'bss-watcher-hide';
        /**
         * @desc is watcher disabled
         * @type {boolean}
         */
        this.disabled = this._config.disabled || false;
        /**
         * @desc scope of parent which is hidden
         * @type {jQuery|HTMLElement} parent scope of watcher
         * @private
         */
        this._parentScope = this._config.parentSelector
            ? _toolbox.$(this._config.parentSelector)
            : null;
        /**
         * @desc scope of watcher which is hidden
         * @type {jQuery | HTMLElement}
         * @private
         */
        this._watcherScope = this._checkWatcherScope();
        if (this._config.boundDataOperand === 'subscriber') {
            this._validateSubscriberWatcherConfig(config);
            this._setEventSubscribers();
        }
        else {
            this._validateWatcherConfig(config);
            this._setSubscribers();
            this._setBoundObjects(this._config[this._config.boundDataOperand]);
            this.checkState('', this._componentConfig);
        }
        logger.info('Watcher for ' + this._componentConfig.componentId + '| Params: ', componentTemplate, componentConfig, config, toolbox, logger, eventManager);
    }
    /**
     * @desc method that check scope of watcher
     * @private
     * @return {jQuery|HTMLElement} scope of watcher
     */
    BSSWatcher.prototype._checkWatcherScope = function () {
        logger.info('Watcher for ' +
            this._componentConfig.componentId +
            ' => _checkWatcherScope');
        var watcherScope;
        if (typeof this._config.elementSelector === 'undefined') {
            watcherScope = this._componentTemplate;
        }
        else {
            watcherScope = this._componentTemplate.find(this._config.elementSelector);
        }
        return watcherScope;
    };
    /**
     * @desc method set all subscribers
     * @listens {bss-component-data-rebound-COMPONENT-ID}
     * @private
     */
    BSSWatcher.prototype._setSubscribers = function () {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => _setSubscribers');
        this._eventManager.subscribe('bss-component-data-rebound-' + this._componentConfig.componentId, this.checkState.bind(this), 'watcher-' + this._subscriberPrefix);
    };
    /**
     * @desc method set subscriber
     * @listens {bss-component-data-rebound-COMPONENT-ID}
     * @private
     */
    BSSWatcher.prototype._setEventSubscribers = function () {
        logger.info('Watcher for ' +
            this._componentConfig.componentId +
            ' => _setEventSubscribers');
        var eventName = this._config.subscriberName.replace('@entityInstanceId@', this._componentConfig.entityInstanceId);
        this._eventManager.subscribe(eventName, this._eventSubscribersCompare.bind(this), 'watcher-' + this._subscriberPrefix);
    };
    /**
     * @desc method check respond from reseved event
     * @param {String} name - event name
     * @param {*} value - event respond
     * @private
     */
    BSSWatcher.prototype._eventSubscribersCompare = function (name, value) {
        logger.info('Watcher for ' +
            this._componentConfig.componentId +
            ' => _eventSubscribersCompare | Param:', name, value);
        var result = !!this._getValueFromRespond(this._config.operandRespond, value);
        this._execWatcher(result);
    };
    /**
     * @desc method destroys watcher: unsubscribe events
     * @public
     */
    BSSWatcher.prototype.destroy = function () {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => destroy');
        this._eventManager.unsubscribeByOwner('watcher-' + this._subscriberPrefix);
    };
    /**
     * @desc method sets prodct id value and varable name value to observe
     * @param {string[] | string} boundArray
     * @throws {Watcher: Wrong boundData format, component ' + this._componentConfig} throw error when bound data format is incorrect
     * @private
     */
    BSSWatcher.prototype._setBoundObjects = function (boundArray) {
        logger.info('Watcher for ' +
            this._componentConfig.componentId +
            ' => _setBoundObjects | Param:', boundArray);
        try {
            boundArray = this._getArray(boundArray);
            /**
             * To be used to parse path to real data
             */
            this.boundObjects = boundArray.map(function (boundVal) {
                var tmp = boundVal === null || boundVal === void 0 ? void 0 : boundVal.split('.');
                var boundObject = {};
                if (tmp && tmp.length > 1) {
                    boundObject = {
                        product: tmp[0],
                        variable: tmp[1],
                    };
                    if (tmp[2]) {
                        boundObject.objSrc = tmp[1];
                        boundObject.componentType = tmp[2];
                        boundObject.componentUniqueId = tmp[3];
                        boundObject.variable = tmp[4];
                    }
                }
                else {
                    boundObject = {
                        product: null,
                        variable: (tmp && tmp[0]) || null,
                    };
                }
                return boundObject;
            });
        }
        catch (e) {
            throw ('Watcher: Wrong boundData format, component ' + this._componentConfig);
        }
    };
    /**
     * @desc method get values from publish object.
     * @param {String} boundString
     * @param {Object} value
     * @throws {Watcher: Wrong boundData format, component ' + this._componentConfig} throw error when bound data format is incorrect
     * @returns {*}
     * @private
     */
    BSSWatcher.prototype._getValueFromRespond = function (boundString, value) {
        logger.info('Watcher for ' +
            this._componentConfig.componentId +
            ' => _getValueFromRespond | Param:', boundString);
        var tmp = boundString.split('.');
        var result = null;
        try {
            for (var _i = 0, tmp_1 = tmp; _i < tmp_1.length; _i++) {
                var key = tmp_1[_i];
                if (result === null &&
                    value &&
                    Object.prototype.hasOwnProperty.call(value, key)) {
                    result = value[key];
                    break;
                }
                else if (result &&
                    Object.prototype.hasOwnProperty.call(result, key)) {
                    result = result[key];
                    break;
                }
                else {
                    return null;
                }
            }
            if (this._config.operandMatch) {
                return result && this._config.operandMatch.indexOf(result) !== -1;
            }
            return result;
        }
        catch (e) {
            throw ('Watcher: Wrong boundData format, component ' + this._componentConfig);
        }
    };
    /**
     * Helpers do czytania wartości z żywego formularza (jQuery).
     * Zgodne ze sposobem z _getFinancialFormData.
     */
    BSSWatcher.prototype._liveGetValue = function ($form, name) {
        var $el = $form.find("[name=\"".concat(name, "\"]"));
        return $el.length && !$el.is(':disabled') ? $el.val() : null;
    };
    BSSWatcher.prototype._liveGetRadioValue = function ($form, name) {
        var $checked = $form.find("[name=\"".concat(name, "\"]:checked"));
        return $checked.length && !$checked.is(':disabled') ? $checked.val() : null;
    };
    /**
     * Zwraca tablicę wartości dla wskazanych name’ów (inputy/checkboxy/selecty),
     * plus radioNames dla grup radiowych.
     */
    BSSWatcher.prototype._getLiveNamesValues = function ($form, names, radioNames) {
        if (names === void 0) { names = []; }
        if (radioNames === void 0) { radioNames = []; }
        var values = [];
        for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
            var n = names_1[_i];
            values.push(this._liveGetValue($form, n));
        }
        for (var _a = 0, radioNames_1 = radioNames; _a < radioNames_1.length; _a++) {
            var rn = radioNames_1[_a];
            values.push(this._liveGetRadioValue($form, rn));
        }
        return values;
    };
    /**
     * Wariant grupowy jak w _getFinancialFormData — buduje wartości dla N-tej podsekcji.
     * Użyteczne, gdy chcesz w 1 watcherze „skondensować” sprawdzanie całej podsekcji.
     */
    BSSWatcher.prototype._getLiveGroupValues = function ($form, _a) {
        var prefix = _a.prefix, index = _a.index, withRadio = _a.withRadio;
        var suffix = index === 1 ? '' : index;
        var amount = this._liveGetValue($form, "".concat(prefix, "Amount").concat(suffix));
        var freq = this._liveGetValue($form, "".concat(prefix, "Frequency").concat(suffix));
        var type = this._liveGetValue($form, "".concat(prefix, "Type").concat(suffix));
        var netOrGross = withRadio
            ? this._liveGetRadioValue($form, "".concat(prefix, "NetOrGross").concat(suffix))
            : null;
        return { amount: amount, freq: freq, type: type, netOrGross: netOrGross };
    };
    /**
     * „Any/All filled” – logika ewaluacji czy podsekcja jest „uzupełniona”.
     */
    BSSWatcher.prototype._evaluateFilled = function (values, mode) {
        if (mode === void 0) { mode = 'any'; }
        var isFilled = function (v) {
            return v !== null &&
                v !== undefined &&
                v !== '' &&
                !(typeof v === 'number' && Number.isNaN(v));
        };
        if (mode === 'all')
            return values.every(isFilled);
        return values.some(isFilled); // default: any
    };
    /**
     * @desc callback on event subscribe
     * @param {String} publisherName
     * @param {Object} data
     * @throws {Watcher for COMPONENT-ID condition is not supported} throw error when condition method is not supported
     * @public
     */
    BSSWatcher.prototype.checkState = function (publisherName, data) {
        var _this = this;
        logger.info('Watcher for ' +
            this._componentConfig.componentId +
            ' => _checkState | Params:', publisherName, data);
        if (this._config.checkLiveForm) {
            var $form = _toolbox.$(this._config.liveFormSelector);
            if (!$form || !$form.length) {
                this['_' + this._conditionFailedCallback]();
                return;
            }
            var names = this._config.liveNames || [];
            var radioNames = this._config.liveRadioNames || [];
            var liveValues = this._getLiveNamesValues($form, names, radioNames);
            if (this._config.liveGroup) {
                var _a = this._config.liveGroup, prefix = _a.prefix, index = _a.index, withRadio = _a.withRadio;
                var g = this._getLiveGroupValues($form, { prefix: prefix, index: index, withRadio: withRadio });
                var coercedAmount = g.amount != null && g.amount !== '' ? parseFloat(g.amount) : null;
                liveValues = __spreadArray([
                    g.type,
                    g.freq,
                    coercedAmount
                ], (withRadio ? [g.netOrGross] : []), true);
            }
            var mode = this._config.liveEvalMode || 'any';
            var boolResult = this._evaluateFilled(liveValues, mode);
            var operandResult = void 0;
            if (boolResult === false) {
                operandResult = null;
            }
            else {
                operandResult = boolResult;
            }
            var operandsRight_1 = this._config.boundDataOperand === 'operandRight'
                ? [operandResult]
                : [true];
            var operandsLeft_1 = this._config.boundDataOperand === 'operandLeft'
                ? [operandResult]
                : [true];
            var operators = this._getArray(this._config.operator || 'is');
            var result = this._callWatcherCondition(operators, operandsLeft_1, operandsRight_1);
            this._execWatcher(result);
            return;
        }
        if (this.disabled &&
            this._componentConfig.componentType !== 'HeaderComponent') {
            return;
        }
        var newValues = [];
        try {
            newValues = this.boundObjects.map(function (boundObject) {
                var _a;
                var newValue;
                if (_this._config.checkFlat && _toolbox.resultDataFlat) {
                    newValue =
                        _toolbox.resultDataFlat[boundObject.product][boundObject.variable];
                }
                else if (_this._config.checkGeneral) {
                    if (data.texts &&
                        data.texts.general &&
                        boundObject.product === 'general') {
                        newValue = data.texts.general[boundObject.variable];
                    }
                    else if ((_a = _toolbox === null || _toolbox === void 0 ? void 0 : _toolbox.layoutTexts) === null || _a === void 0 ? void 0 : _a.general) {
                        newValue = _toolbox.layoutTexts.general[boundObject.variable];
                    }
                    else {
                        return '';
                    }
                }
                else if (boundObject.componentType) {
                    // check error list
                    if (boundObject.objSrc === 'errors') {
                        var errorList = data.resultData[boundObject.product].errors;
                        for (var errorProperty in errorList) {
                            if (Object.prototype.hasOwnProperty.call(errorList, errorProperty) &&
                                errorProperty === boundObject.componentType) {
                                newValue = errorList[errorProperty];
                            }
                        }
                    }
                    else {
                        // check component list
                        var currentComponentType = data.resultData[boundObject.product][boundObject.objSrc][boundObject.componentType];
                        for (var i = 0, len = currentComponentType.length; i < len; i++) {
                            if (currentComponentType[i].name === boundObject.componentUniqueId) {
                                newValue = currentComponentType[i][boundObject.variable];
                            }
                        }
                    }
                }
                else if (_this._config.checkTexts) {
                    if (data.texts === undefined) {
                        newValue = _this._componentConfig.texts[boundObject.product][boundObject.variable]
                            ? _this._componentConfig.texts[boundObject.product][boundObject.variable]
                            : null;
                    }
                    else {
                        newValue = data.texts[boundObject.product][boundObject.variable]
                            ? data.texts[boundObject.product][boundObject.variable]
                            : null;
                    }
                }
                else {
                    if (data.resultData[boundObject.product][boundObject.variable] === 0) {
                        newValue =
                            data.resultData[boundObject.product][boundObject.variable];
                    }
                    else if (boundObject.product) {
                        newValue = data.resultData[boundObject.product][boundObject.variable]
                            ? data.resultData[boundObject.product][boundObject.variable]
                            : null;
                    }
                    else {
                        newValue = (boundObject === null || boundObject === void 0 ? void 0 : boundObject.variable) || null;
                    }
                }
                return newValue;
            });
        }
        catch (err) {
            //when value was removed from resultData we assume that such a case is considered as fail
            this['_' + this._conditionFailedCallback]();
        }
        var operandsRight;
        var operandsLeft;
        if (this._config.boundDataOperand === 'operandRight') {
            operandsRight = this._getArray(newValues);
            operandsLeft = this._getArray(this._config.operandLeft);
        }
        else {
            operandsRight = this._getArray(this._config.operandRight);
            operandsLeft = this._getArray(newValues);
        }
        if (this._config.operator === 'indexOf') {
            operandsRight = [operandsRight];
        }
        try {
            var operators = this._getArray(this._config.operator);
            var result = this._callWatcherCondition(operators, operandsLeft, operandsRight);
            this._execWatcher(result);
        }
        catch (e) {
            throw ('Watcher for component with id: ' +
                this._componentConfig.componentId +
                ' condition is not supported');
        }
    };
    /**
     * Return array type of the value
     * @param value
     * @returns {*|*[]}
     * @private
     */
    BSSWatcher.prototype._getArray = function (value) {
        logger.info('Watcher for ' +
            this._componentConfig.componentId +
            ' => _getArray | Param:', value);
        return isArray(value) ? value : [value];
    };
    /**
     *
     * @param {string[]} operators
     * @param {string[]} operandsLeft
     * @param {string[]} operandsRight
     * @returns {boolean}
     * @private
     */
    BSSWatcher.prototype._callWatcherCondition = function (operators, operandsLeft, operandsRight) {
        var _this = this;
        logger.info('Watcher for ' +
            this._componentConfig.componentId +
            ' => _callWatcherCondition | Param:', operators, operandsLeft, operandsRight);
        var results;
        try {
            results = operators.map(function (operator, index) {
                return _this['_' + operator](operandsLeft[index], operandsRight[index]);
            });
        }
        catch (err) {
            throw ('Watcher for component with id: ' +
                this._componentConfig.componentId +
                ' watcher data are incompatible: ' +
                err);
        }
        var _a = this._config.watcherStateType, watcherStateType = _a === void 0 ? 'AND' : _a;
        if (watcherStateType === 'AND') {
            // if all conditions are true
            return !results.some(function (result) { return !result; });
        }
        else if (watcherStateType === 'OR') {
            // if at least one condition is true
            return results.some(function (result) { return result; });
        }
        else {
            throw ('Watcher for component with id: ' +
                this._componentConfig.componentId +
                ' watcher state type is not supported. Please, use "OR" or "AND" state type');
        }
    };
    /**
     * Execute watcher callback depending on all result for watchers used on current components
     * @param {boolean} result watcher result
     */
    BSSWatcher.prototype._execWatcher = function (result) {
        var _this = this;
        logger.info('Watcher for ' +
            this._componentConfig.componentId +
            ' => _execWatcher | Param:', result);
        var callbacks = result
            ? this._getArray(this._conditionSuccessCallback)
            : this._getArray(this._conditionFailedCallback);
        callbacks.forEach(function (callback) {
            _this['_' + callback]();
        });
    };
    /**
     * @desc method:  When value are not NULL, empty string and undefined, check if value egzist in array.
     * @param operandLeft
     * @param operandRight
     * @returns {boolean}
     * @private
     */
    BSSWatcher.prototype._indexOf = function (operandLeft, operandRight) {
        logger.info('Watcher for ' +
            this._componentConfig.componentId +
            ' => _indexOf | _match:', operandLeft, operandRight);
        if (!(operandLeft === null ||
            operandLeft === undefined ||
            operandLeft === '') &&
            _toolbox._.isArray(operandRight)) {
            var operand = _toolbox._.isString(operandLeft)
                ? operandLeft.toString().toLowerCase()
                : operandLeft; // All string change to LowerCase
            if (operandRight.indexOf(operand) !== -1) {
                return true;
            }
        }
        return false;
    };
    /**
     * @desc method:  When value are not NULL, empty string and undefined, fires this._conditionSuccessCallback, otherwise this._conditionFailedCallback is called
     * @param operandLeft
     * @returns {boolean}
     * @private
     */
    BSSWatcher.prototype._is = function (operandLeft) {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => _is | _egz:', operandLeft);
        return !(operandLeft === null ||
            operandLeft === undefined ||
            operandLeft === '');
    };
    /**
     * @desc method:  When two values are equal, value === condition, fires this._conditionSuccessCallback, otherwise this._conditionFailedCallback is called
     * @param {Number|String|Array} operandLeft - left operand
     * @param {Number|String|Array} operandRight - right operand
     * @returns {boolean}
     * @private
     */
    BSSWatcher.prototype._eq = function (operandLeft, operandRight) {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => _eq | Params:', operandLeft, operandRight);
        return operandLeft === operandRight;
    };
    /**
     * @desc method:  When two values are not equal, value !== condition, fires this._conditionSuccessCallback, otherwise this._conditionFailedCallback is called
     * @param {Number|String|Array} operandLeft - left operand
     * @param {Number|String|Array} operandRight - right operand
     * @returns {boolean}
     * @private
     */
    BSSWatcher.prototype._neq = function (operandLeft, operandRight) {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => _neq | Params:', operandLeft, operandRight);
        return operandLeft !== operandRight && operandRight !== null;
    };
    /**
     * @desc method:  When one value is greater than another, value > condition, fires this._conditionSuccessCallback, otherwise this._conditionFailedCallback is called
     * @param {Number} operandLeft - left operand
     * @param {Number} operandRight - right operand
     * @returns {boolean}
     * @private
     */
    BSSWatcher.prototype._gt = function (operandLeft, operandRight) {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => _gt | Param:', operandLeft, operandRight);
        return operandLeft > operandRight;
    };
    /**
     * @desc method:  When one value is greater or equal than another, value >= condition, fires this._conditionSuccessCallback, otherwise this._conditionFailedCallback is called
     * @param {Number} operandLeft - left operand
     * @param {Number} operandRight - right operand
     * @returns {boolean}
     * @private
     */
    BSSWatcher.prototype._gte = function (operandLeft, operandRight) {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => _gte | Param:', operandLeft, operandRight);
        return operandLeft >= operandRight;
    };
    /**
     * @desc method:  When one value is smaller than another, value < condition, fires this._conditionSuccessCallback, otherwise this._conditionFailedCallback is called
     * @param {Number} operandLeft - left operand
     * @param {Number} operandRight - right operand
     * @returns {boolean}
     * @private
     */
    BSSWatcher.prototype._lt = function (operandLeft, operandRight) {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => _lt | Param:', operandLeft, operandRight);
        return operandLeft < operandRight;
    };
    /**
     * @desc method:  When one value is smaller or equal than another, value <= condition, fires this._conditionSuccessCallback, otherwise this._conditionFailedCallback is called
     * @param {Number} operandLeft - left operand
     * @param {Number} operandRight - right operand
     * @returns {boolean}
     * @private
     */
    BSSWatcher.prototype._lte = function (operandLeft, operandRight) {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => _lte | Param:', operandLeft, operandRight);
        return operandLeft <= operandRight;
    };
    /**
     * @desc method shows component
     * @private
     * @emits {bss-watcher-show-$ENTITY-INSTANCE-ID} public event
     */
    BSSWatcher.prototype._show = function () {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => _show');
        this._state = 'show';
        this._watcherScope.removeClass(this.hideClass);
        if (this._parentScope) {
            this._parentScope.removeClass(this.hideClass);
        }
        this._eventManager.publish('bss-watcher-show-' + this._componentConfig.entityInstanceId, this._componentConfig.componentType +
            '-' +
            this._componentConfig.componentId);
    };
    /**
     * @desc method hides component
     * @private
     */
    BSSWatcher.prototype._hide = function () {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => _hide');
        this._state = 'hide';
        this._watcherScope.addClass(this.hideClass);
        if (this._parentScope) {
            this._parentScope.addClass(this.hideClass);
        }
    };
    /**
     * @desc method add class to component
     * @private
     */
    BSSWatcher.prototype._addClass = function () {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => _addClass');
        this._watcherScope.addClass(this._config.className || this.hideClass);
        if (this._parentScope) {
            this._parentScope.addClass(this._config.className || this.hideClass);
        }
    };
    /**
     * @desc method remove class from component
     * @private
     */
    BSSWatcher.prototype._removeClass = function () {
        logger.info('Watcher for ' + this._componentConfig.componentId + ' => _removeClass');
        this._watcherScope.removeClass(this._config.className || this.hideClass);
        if (this._parentScope) {
            this._parentScope.removeClass(this._config.className || this.hideClass);
        }
    };
    /**
     * @desc validate if configuration of component are valid
     * @typedef {Object} config
     * @private
     */
    BSSWatcher.prototype._validateWatcherConfig = function (config) {
        logger.info('Watcher for ' +
            this._componentConfig.componentId +
            ' => _validateWatcherConfig | Params:', config);
        if (config.checkLiveForm)
            return;
        if (!(_toolbox._.has(config, 'boundDataOperand') &&
            _toolbox._.has(config, 'effectSuccess') &&
            _toolbox._.has(config, 'effectFail') &&
            _toolbox._.has(config, 'operandLeft') &&
            _toolbox._.has(config, 'operator'))) {
            throw ('Wacher for component with id: ' +
                this._componentConfig.componentId +
                ' has incorrect config!');
        }
    };
    /**
     * @desc validate if configuration of component are valid
     * @typedef {Object} config
     * @private
     */
    BSSWatcher.prototype._validateSubscriberWatcherConfig = function (config) {
        logger.info('Watcher for ' +
            this._componentConfig.componentId +
            ' => _validateSubscriberWatcherConfig | Params:', config);
        if (!(_toolbox._.has(config, 'boundDataOperand') &&
            _toolbox._.has(config, 'effectSuccess') &&
            _toolbox._.has(config, 'effectFail') &&
            _toolbox._.has(config, 'subscriberName') &&
            _toolbox._.has(config, 'operandRespond'))) {
            throw ('Watcher for component with id: ' +
                this._componentConfig.componentId +
                ' has incorrect config!');
        }
    };
    return BSSWatcher;
}());
export default BSSWatcher;
